import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.push.js";
import { extractArticleSectionsFromBody, sanitizeArticle } from "@faire/help-center-utils/lib/articleFormatter";
import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { articleBodyPlaceholder } from "@faire/help-center-utils/lib/random";
import { isHiddenSection } from "@faire/help-center/consts";
import { useSectionStore } from "@faire/help-center/hooks/useSectionStore";
import { useQuery as useZendeskArticles } from "@faire/web-api/api/zendesk/locale/articles/articleId/get-hooks";
import { trackHelpCenterArticleViewTraceError } from "@faire/web-api/events/helpCenter/view/article";
import home from "@faire/web-api/routes/support";
import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useArticleContextStore } from "./ArticleContext";
import { useArticleId } from "./useArticleId";
export var useArticlesDataFetch = function useArticlesDataFetch() {
  var _zendeskArticleData$a, _zendeskArticleData$s;
  var history = useHistory();
  var articleId = useArticleId();
  var _useArticleContextSto = useArticleContextStore(["articleData", "isLoading"]),
    _useArticleContextSto2 = _slicedToArray(_useArticleContextSto, 2),
    _useArticleContextSto3 = _useArticleContextSto2[0],
    articleData = _useArticleContextSto3.articleData,
    isLoading = _useArticleContextSto3.isLoading,
    setArticleContextStore = _useArticleContextSto2[1];
  var _useSectionStore = useSectionStore(),
    isSectionStoreLoading = _useSectionStore.isLoading,
    sectionStoreDataUpdatedAt = _useSectionStore.dataUpdatedAt;
  var _useZendeskArticles = useZendeskArticles(localeString, articleId !== null && articleId !== void 0 ? articleId : "", {
      include: undefined
    }, {
      enabled: !!articleId && articleData && articleData.article && articleId !== String(articleData.article.id)
    }, {
      rawResponse: true
    }),
    zendeskArticleRawResponse = _useZendeskArticles.data,
    isLoadingArticle = _useZendeskArticles.isLoading,
    isZendeskArticleError = _useZendeskArticles.isError,
    fetchStatusArticle = _useZendeskArticles.fetchStatus,
    isFetchingArticle = _useZendeskArticles.isFetching,
    articlesDataUpdatedAt = _useZendeskArticles.dataUpdatedAt,
    isSuccess = _useZendeskArticles.isSuccess;
  if (isZendeskArticleError) {
    trackHelpCenterArticleViewTraceError();
    history.push(home());
  }
  var _ref = zendeskArticleRawResponse !== null && zendeskArticleRawResponse !== void 0 ? zendeskArticleRawResponse : {},
    zendeskArticleDataInCurrentLocale = _ref.data,
    statusCode = _ref.status;
  var _useZendeskArticles2 = useZendeskArticles("en-us", articleId !== null && articleId !== void 0 ? articleId : "", {
      include: undefined
    }, {
      enabled: localeString !== "en-us" && statusCode === 204
    }),
    zendeskArticleDataInEnglish = _useZendeskArticles2.data;
  // Use the article data in the current locale if it exists, otherwise use the English version
  var zendeskArticleData = zendeskArticleDataInCurrentLocale !== null && zendeskArticleDataInCurrentLocale !== void 0 ? zendeskArticleDataInCurrentLocale : zendeskArticleDataInEnglish;
  var currentSectionId = zendeskArticleData === null || zendeskArticleData === void 0 ? void 0 : (_zendeskArticleData$a = zendeskArticleData.article) === null || _zendeskArticleData$a === void 0 ? void 0 : _zendeskArticleData$a.section_id;
  var articleSection = zendeskArticleData === null || zendeskArticleData === void 0 ? void 0 : (_zendeskArticleData$s = zendeskArticleData.sections) === null || _zendeskArticleData$s === void 0 ? void 0 : _zendeskArticleData$s[0];
  useEffect(function () {
    setArticleContextStore({
      articleData: zendeskArticleData,
      isLoading: isLoadingArticle && fetchStatusArticle !== "idle" || isSectionStoreLoading
    });
  }, [zendeskArticleData, isLoadingArticle, fetchStatusArticle, isSectionStoreLoading, setArticleContextStore]);
  var article = articleData === null || articleData === void 0 ? void 0 : articleData.article;
  var sanitizedArticleBody = useMemo(function () {
    if (!(article !== null && article !== void 0 && article.body)) {
      return articleBodyPlaceholder;
    }
    return sanitizeArticle(article.body);
  }, [article === null || article === void 0 ? void 0 : article.body]);
  var articleSections = article !== null && article !== void 0 && article.body ? extractArticleSectionsFromBody(article.body) : undefined;
  var inHiddenSection = article && isHiddenSection(article.section_id);
  var dataUpdatedAt = getLatestDataUpdatedAt([sectionStoreDataUpdatedAt, articlesDataUpdatedAt]);
  return {
    article: article,
    isLoading: isLoading || isFetchingArticle || isSectionStoreLoading,
    sanitizedArticleBody: sanitizedArticleBody,
    articleSections: articleSections,
    inHiddenSection: inHiddenSection,
    articleSection: articleSection,
    currentSectionId: currentSectionId,
    dataUpdatedAt: dataUpdatedAt,
    isSuccess: isSuccess
  };
};